var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFlorida(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 238.91 48.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.16,46.38A9.69,9.69,0,0,1,0,39V9.53C0,6.3,1.47,4.34,3.93,2.66A6.17,6.17,0,0,1,7.72,2c1.19.14,3.16.35,6,3,1.13,1.06,8.15,6.31,9.2,7.78S25.26,15.7,25.61,17a5.26,5.26,0,0,1-1.47,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.46,0h30.8C46.52,0,50,4.14,50,9.39V39a9.27,9.27,0,0,1-9.4,9.39H15.16C20,42.46,30.8,28.24,32.42,26.21c1.75-2.25,5.4-.22,5.4-.22l7.51,5.19,4.49-6s-1.89-1.26-4-3C41.26,18.36,35.09,12.61,31,10A109.38,109.38,0,0,0,12.07.77,8.87,8.87,0,0,0,10.81.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.19,48.29a1.8,1.8,0,0,1-.59-.41,1.87,1.87,0,0,1-.41-.61,2,2,0,0,1,0-1.42,1.83,1.83,0,0,1,.41-.6,1.69,1.69,0,0,1,.59-.42,1.95,1.95,0,0,1,1.4,0,1.69,1.69,0,0,1,.59.42,1.92,1.92,0,0,1,.4,2,1.84,1.84,0,0,1-.4.61,1.8,1.8,0,0,1-.59.41,1.95,1.95,0,0,1-1.4,0m.09-3.23a1.63,1.63,0,0,0-.87.87,1.86,1.86,0,0,0,0,1.26,1.64,1.64,0,0,0,.35.52,1.62,1.62,0,0,0,.52.36,1.51,1.51,0,0,0,.61.12,1.56,1.56,0,0,0,.62-.12,1.49,1.49,0,0,0,.51-.36,1.75,1.75,0,0,0,.34-1.78,1.73,1.73,0,0,0-.34-.52,1.6,1.6,0,0,0-.51-.35,1.56,1.56,0,0,0-.62-.12h0a1.51,1.51,0,0,0-.61.13m-.24.41h1s0,0,0,0h.22l.08,0,.07,0a.36.36,0,0,1,.09.08.36.36,0,0,1,.07.1.45.45,0,0,1,0,.11.5.5,0,0,1,0,.12.51.51,0,0,1,0,.22.29.29,0,0,1-.12.15.52.52,0,0,1-.19.11.46.46,0,0,1-.2.05l.11,0,.09.08.08.1.06.11,0,.06,0,0,0,.05s0,0,0,0v0a.06.06,0,0,1,0,0,.08.08,0,0,1,0,0l0,0v0l0,0v0l0,0s0,0,0,0v0h0v0l0,0,0,0h.12v.08h-.36l-.05,0a.05.05,0,0,1,0,0l0,0,0-.06,0,0,0-.07s0,0,0,0l0,0a.43.43,0,0,0,0,0s0,0,0,0,0,0,0,0h0v0a0,0,0,0,0,0,0s0,0,0,0,0,0,0,0l0-.06a.25.25,0,0,1,0-.07,0,0,0,0,0,0,0l0,0,0,0v0l0,0,0,0h-.33v.67a.22.22,0,0,0,0,.09.35.35,0,0,0,0,.06.09.09,0,0,0,.05,0l.08,0h.1v.09H51v-.09h.1l.07,0h0s0,0,0,0,0,0,0-.08V45.71a.64.64,0,0,0,0-.07.05.05,0,0,0,0,0l0,0h-.09l-.08,0Zm.66,1a.85.85,0,0,0,.23,0,.68.68,0,0,0,.2-.07.32.32,0,0,0,.15-.13.57.57,0,0,0,0-.24.54.54,0,0,0,0-.2.34.34,0,0,0-.09-.14A.48.48,0,0,0,52,45.6a.58.58,0,0,0-.19,0h-.14l-.09,0,0,0s0,0,0,.07a.15.15,0,0,0,0,.07h0v.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.84,10.88H75.91V16h2.93c1.9,0,3.09-1,3.09-2.58,0-1.69-1.21-2.58-3.09-2.58m-.09,7.44H75.91v4.6H73.39V8.59H79c3.34,0,5.45,1.89,5.45,4.81,0,3.24-2.58,4.92-5.74,4.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.16,11.5l-2.45,5.73h4.93Zm7.52,11.42H97l-1.46-3.46H88.78l-1.47,3.46H84.73L91,8.49h2.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.22 8.59 114.7 8.59 114.7 22.92 112.59 22.92 104.69 12.73 104.69 22.92 102.21 22.92 102.21 8.59 104.55 8.59 112.22 18.5 112.22 8.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.15,11.5l-2.46,5.73h4.94Zm7.51,11.42H136l-1.45-3.46h-6.78l-1.47,3.46h-2.58L130,8.49h2.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "148.24 19.4 148.16 19.4 143.68 12.69 143.68 22.93 141.2 22.93 141.2 8.59 143.88 8.59 148.24 15.37 152.6 8.59 155.29 8.59 155.29 22.93 152.77 22.93 152.77 12.65 148.24 19.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "169.93 10.84 161.82 10.84 161.82 14.57 169.01 14.57 169.01 16.82 161.82 16.82 161.82 20.67 170.03 20.67 170.03 22.92 159.3 22.92 159.3 8.59 169.93 8.59 169.93 10.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.5,10.88h-3.66V15.7h3.68c1.8,0,2.95-.95,2.95-2.42s-1.11-2.4-3-2.4m3,12-3.52-5h-3.15v5h-2.52V8.59h6.39c3.29,0,5.32,1.74,5.32,4.55a4.29,4.29,0,0,1-3.42,4.36l3.87,5.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 188.43,
    y: 8.59,
    width: 2.52,
    height: 14.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.54,23.17a7.21,7.21,0,0,1-7.29-7.39,7.25,7.25,0,0,1,7.39-7.43,7.45,7.45,0,0,1,5.61,2.23l-1.61,1.86a5.74,5.74,0,0,0-4-1.78,4.82,4.82,0,0,0-4.73,5.08,4.86,4.86,0,0,0,4.73,5.12A5.61,5.61,0,0,0,205.74,19l1.62,1.64a7.41,7.41,0,0,1-5.82,2.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.37,11.5l-2.45,5.73h4.93Zm7.52,11.42h-2.66l-1.46-3.46H213l-1.48,3.46h-2.58l6.31-14.43h2.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "236.44 8.59 238.91 8.59 238.91 22.92 236.81 22.92 228.9 12.73 228.9 22.92 226.42 22.92 226.42 8.59 228.76 8.59 236.44 18.5 236.44 8.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.06,36.12c2.16.53,3.28,1.3,3.28,3,0,1.93-1.5,3.06-3.64,3.06a6.32,6.32,0,0,1-4.26-1.63l1.08-1.28a4.73,4.73,0,0,0,3.22,1.33c1.11,0,1.8-.51,1.8-1.3s-.4-1.14-2.3-1.57c-2.17-.53-3.39-1.17-3.39-3.06s1.46-3,3.48-3A5.64,5.64,0,0,1,122,33l-1,1.35a4.68,4.68,0,0,0-2.77-1c-1,0-1.66.54-1.66,1.23s.47,1.15,2.42,1.61"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 131.13,
    y: 31.84,
    width: 1.79,
    height: 10.19
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "142.24 31.84 144.03 31.84 144.03 40.41 149.39 40.41 149.39 42.04 142.24 42.04 142.24 31.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "163.63 31.84 165.56 31.84 161.32 42.11 159.75 42.11 155.51 31.84 157.49 31.84 160.57 39.68 163.63 31.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "181.37 33.44 175.61 33.44 175.61 36.09 180.72 36.09 180.72 37.7 175.61 37.7 175.61 40.43 181.45 40.43 181.45 42.04 173.81 42.04 173.81 31.84 181.37 31.84 181.37 33.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.63,33.47H192V36.9h2.62c1.29,0,2.1-.67,2.1-1.72s-.79-1.71-2.11-1.71M196.77,42l-2.5-3.56H192V42h-1.79V31.84h4.54c2.35,0,3.79,1.24,3.79,3.24a3.06,3.06,0,0,1-2.43,3.1L198.88,42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.03,
    y: 36.39,
    width: 21.29,
    height: 1.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 217.12,
    y: 36.39,
    width: 21.29,
    height: 1.32
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFlorida);
export default __webpack_public_path__ + "static/media/logo-florida.45964bf563e2d69542708e014c9d39df.svg";
export { ForwardRef as ReactComponent };